/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Config-Service
 * Service delivers configs.
 * OpenAPI spec version: v1.0.0
 */
import { adapter } from './adapter';
export type PageTypes = typeof PageTypes[keyof typeof PageTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PageTypes = {
  start: 'start',
  landing: 'landing',
  fallback: 'fallback',
  sea: 'sea',
  ibe: 'ibe',
  category: 'category',
  hotelDetail: 'hotelDetail',
  error: 'error',
  book: 'book',
  bookConfirm: 'bookConfirm',
  wishlist: 'wishlist',
  partner: 'partner',
  'cruises-partner': 'cruises-partner',
  login: 'login',
  'ibe-hotel-list': 'ibe-hotel-list',
  'ibe-offer-list': 'ibe-offer-list',
} as const;

export type Devices = typeof Devices[keyof typeof Devices];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Devices = {
  lg: 'lg',
  md: 'md',
  sm: 'sm',
} as const;

export type Platforms = typeof Platforms[keyof typeof Platforms];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Platforms = {
  de: 'de',
  at: 'at',
  ch: 'ch',
  cz: 'cz',
  pl: 'pl',
  sk: 'sk',
  hu: 'hu',
} as const;

export type Agents = typeof Agents[keyof typeof Agents];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Agents = {
  'aidu-de': 'aidu-de',
  'aidu-at': 'aidu-at',
  'aidu-ch': 'aidu-ch',
  'invia-cz': 'invia-cz',
  'invia-sk': 'invia-sk',
  'invia-hu': 'invia-hu',
  'travelplanet-pl': 'travelplanet-pl',
  'reisen-de': 'reisen-de',
  'reisegeier-de': 'reisegeier-de',
  'reisegeier-at': 'reisegeier-at',
  'reisegeier-ch': 'reisegeier-ch',
  'reisen-fluege-de': 'reisen-fluege-de',
  'travelchannel-de': 'travelchannel-de',
} as const;

/**
 * content returns special configs
 */
export interface Configs {
  /** @nullable */
  leadSources: LeadSource[] | null;
  headers: Header[];
  /** @nullable */
  serviceCenterLayers: ServiceCenterLayer[] | null;
  holidays: HolidaysByCountry;
}

export interface LeadSource {
  pageType: PageTypes;
  device: Devices;
  source: string;
}

export interface Header {
  pageType: PageTypes;
  login: boolean;
  favouriteList: boolean;
  sslIcon: boolean;
  accessibilityToggleEnabled: boolean;
  menu?: Menu;
  hotline?: Hotline;
  logo: Logo;
  countrySwitch?: CountrySwitch;
}

export type ImageType = typeof ImageType[keyof typeof ImageType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageType = {
  directus: 'directus',
} as const;

export interface Image {
  url: string;
  type: ImageType;
}

export interface Logo {
  type: string;
  url: string;
  isClickable: boolean;
  alt: string;
  targetUrl?: string;
}

export interface Hotline {
  openingHours: OpeningHours;
  numbers: HotlineNumbers;
  headline: string;
  subHeadline: string;
  teaser: string;
  stickyTeaser: string;
  image: Image;
  stickyImage?: Image;
  specials?: HotlineSpecial[];
}

export interface OpeningHours {
  from: string;
  to: string;
}

export interface HotlineNumbers {
  sm: string;
  md: string;
  lg: string;
}

export interface HotlineSpecial {
  text: string;
  publishDate: string;
  expiryDate: string;
  image: Image;
  items: HotlineSpecialItem[];
}

export interface HotlineSpecialItem {
  id: string;
  date: string;
  from: string;
  to: string;
  icon?: Image;
}

export type LinkItemTarget = typeof LinkItemTarget[keyof typeof LinkItemTarget];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LinkItemTarget = {
  _self: '_self',
  _blank: '_blank',
} as const;

export interface LinkItem {
  id?: string;
  caption: string;
  badge: string;
  target: LinkItemTarget;
  masked: boolean;
  path: string;
}

export interface Menu {
  items: MenuItems[];
}

export interface MenuItems {
  id: string;
  link?: LinkItem;
  caption: string;
  footerLink?: LinkItem;
  items?: SubMenuItems[];
}

export interface SubMenuItems {
  id: string;
  headline: string;
  itemsPerColumn: number;
  items: LinkItem[];
}

export interface CountrySwitch {
  active?: CountrySwitchItem;
  items: CountrySwitchItem[];
}

export interface CountrySwitchItem {
  domain: string;
  name: string;
  countryCode: string;
  icon: Image;
}

export interface HolidaysByCountry {[key: string]: Holidays}

export type Holidays = Holiday[];

export type HolidayType = typeof HolidayType[keyof typeof HolidayType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HolidayType = {
  public: 'public',
  school: 'school',
} as const;

export interface Holiday {
  startDate: string;
  endDate: string;
  type: HolidayType;
}

/**
 * duration values min and max
 */
export interface Duration {
  /** min travel duration */
  min: number;
  /** max travel duration */
  max: number;
}

export interface DestinationType {
  /** name of the type */
  name: string;
  duration?: Duration;
}

export interface Destination {
  destinationType: DestinationType;
  airports?: Airport[];
  airportGroups?: Airport[];
}

export interface Airport {
  /** iatat code */
  code: string;
  nearbyAirports?: NearbyAirport[];
}

export interface NearbyAirport {
  /** distance to airport */
  distance: string;
  airport?: Airport;
}

/**
 * directus service center layer
 */
export interface ServiceCenterLayer {
  pageType: PageTypes;
  device: Devices;
  illustration?: Image;
  /** main text */
  mainText?: string;
  headline?: Headline;
  ctaButtons: CTAButtons;
  weekdays: WorkingLayer;
  weekends?: WorkingLayer;
  /** best time to call text */
  bestTimeToCall?: string;
  contactPageLink?: LinkItem;
  SpecialOpeningHours?: HotlineSpecialItem[];
}

/**
 * weekday working hours
 */
export interface WorkingLayer {
  openingHours: OpeningHours;
  volumeGraphic?: VolumeGraphic;
}

/**
 * peak hour section
 */
export interface VolumeGraphic {
  peakHours: VolumeGraphicItem[];
  /** title of the volume graphic */
  title?: string;
  /** peak hour description */
  description?: string;
}

/**
 * peak hour graph
 */
export interface VolumeGraphicItem {
  /** peak hour */
  hour: string;
  /** capacity percentage */
  capacity: number;
}

/**
 * CTA buttons of hotline
 */
export interface CTAButtons {
  /** show phone number */
  showPhoneNumber: boolean;
  /** phone number caption */
  phoneNumberCaption?: string;
  /** show callback button */
  showCallbackButton: boolean;
  /** callback button caption */
  callbackCaption?: string;
  /** show service & help */
  showServiceHelp: boolean;
  /** Service & Help caption */
  serviceHelpCaption?: string;
  /** Service & Help subline */
  serviceHelpSubline?: string;
  serviceHelpLink?: ItemLink;
  /** show live chat */
  showLiveChat: boolean;
  /** livechat caption */
  livechatCaption?: string;
  /** livechat subline */
  livechatSubline?: string;
}

/**
 * link
 */
export interface ItemLink {
  /** link url (href) */
  url?: string;
  /** link target */
  target?: string;
  /** masked link or not */
  masked?: boolean;
  /** link text */
  text: string;
  /** link description */
  description?: string;
  /** hotel count for sidebar links */
  count?: number;
  /** keyword */
  keyword?: string;
  image?: Image;
  /** campaign name for tracking purposes */
  trackingLabel?: string;
}

/**
 * the headline with text and html node tag
 */
export interface Headline {
  /** the content of the headline */
  text: string;
  /** the content of the subline */
  subline?: string;
  tag: HeadlineTag;
  /** the anchor for the headline */
  anchorId: string;
  /** the position of the headline */
  position?: string;
  /** the size of the headline */
  size?: string;
}

/**
 * HTML tag for the headline
 */
export type HeadlineTag = typeof HeadlineTag[keyof typeof HeadlineTag];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HeadlineTag = {
  span: 'span',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
} as const;

export type ErrorResponse = {
  /** Error code */
  code: number;
  /** Error message */
  message: string;
};

/**
 * success
 */
export type ConfigResponse = Configs;

/**
 * success
 */
export type DestinationResponseResponse = Destination[];

export type ConfigParams = {
/**
 * the platform tld
 */
platform?: Platforms;
/**
 * platform agent
 */
agent?: Agents;
/**
 * device codes
 */
devices?: Devices[];
/**
 * pageType codes
 */
pageTypes: PageTypes[];
};

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

/**
 * Keyword routing to special IBE parameters.
 */
export type configResponse200 = {
  data: ConfigResponse
  status: 200
}

export type configResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type configResponseComposite = configResponse200 | configResponseDefault;
    
export type configResponse = configResponseComposite & {
  headers: Headers;
}

export const getConfigUrl = (params: ConfigParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/config?${stringifiedParams}` : `/config`
}

export const config = async (params: ConfigParams, options?: RequestInit): Promise<configResponse> => {
  
  return adapter<configResponse>(getConfigUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Get information about specified destination.
 */
export type destinationResponse200 = {
  data: DestinationResponseResponse
  status: 200
}

export type destinationResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type destinationResponseComposite = destinationResponse200 | destinationResponseDefault;
    
export type destinationResponse = destinationResponseComposite & {
  headers: Headers;
}

export const getDestinationUrl = (keywordId: string,
    agent: Agents,) => {


  

  return `/destination/${keywordId}/${agent}`
}

export const destination = async (keywordId: string,
    agent: Agents, options?: RequestInit): Promise<destinationResponse> => {
  
  return adapter<destinationResponse>(getDestinationUrl(keywordId,agent),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
